import { render, staticRenderFns } from "./my-cards.vue?vue&type=template&id=c097aa58&"
import script from "./my-cards.vue?vue&type=script&lang=js&"
export * from "./my-cards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports